import { createActions } from 'redux-actions';

export const {
  editOption,
  resetOptions,
  removeOption,
  updateOptions,
  updatePasswordPolicy,
} = createActions(
  'EDIT_OPTION',
  'RESET_OPTIONS',
  'REMOVE_OPTION',
  'UPDATE_OPTIONS',
  'UPDATE_PASSWORD_POLICY',
);
